import { Icon } from "@circle-react-shared/Icon";

import { t } from "@/i18n-js/instance";

export const AgentBadge = () => (
  <span className="text-default border-dark bg-primary inline-flex h-5 items-center gap-1 rounded-xl border px-1.5 py-[3px] pr-2">
    <Icon type="12-ai-agent-badge" size={12} className="!w-3" />
    <span className="text-[0.6rem] font-medium">
      {t("community_bot.profile_tag")}
    </span>
  </span>
);
